import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.querySelectorAll('iframe').forEach(this.#formatIframe);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
  /**
   * Formats an iframe for easier styling
   * @param {HTMLIFrameElement} iframe
   */
  #formatIframe(iframe) {
    iframe.src = iframe.src;
    const wrapper = document.createElement('div');
    wrapper.classList.add('video-wrapper');
    const parent = iframe.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
